import React from 'react';
import PropTypes from 'prop-types';
import './FormButton.scss';

export default function FormButton(props) {
  const { children } = props;
  return (
    <button type="button" {...props} className="custom-button">
      {children}
    </button>
  );
}

FormButton.propTypes = {
  children: PropTypes.node.isRequired,
};
